<template>
  <md-card>
    <md-button
      class="md-just-icon md-round modal-default-button md-simple"
      @click="closeSpiral"
    >
      <md-icon>clear</md-icon>
    </md-button>
    <md-card-header> <h4>Spirala</h4> </md-card-header>
    <md-card-content class="md-layout">
      <md-field class="md-layout-item md-size-20">
        <label> Oznaka spirale </label>
        <md-input type="text" v-model="spiral.name"> </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Boja </label>
        <md-input type="text" v-model="spiral.color"> </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-15">
        <label> Dužina noda </label>
        <md-input type="number" step="0.01" v-model="spiral.nodeLength">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-15">
        <label> Grama po nodu </label>
        <md-input type="number" step="0.0001" v-model="spiral.gramPerNode">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-15">
        <label> Nodova po rolni </label>
        <md-input type="number" step="1" v-model="spiral.nodesPerRoll">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-15">
        <label> Cijena € / m </label>
        <md-input type="number" step="0.01" v-model="spiral.pricePerMeter">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-100">
        <label> Opis </label>
        <md-textarea type="text" v-model="spiral.description"> </md-textarea>
      </md-field>
    </md-card-content>
    <md-card-actions md-alignment="right">
      <md-button class="md-success" @click="saveSpiral">
        <md-icon> save </md-icon>
        Sačuvaj
      </md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import services from '@/api/services';
import api from '@/api/api.js';

export default {
  props: {
    id: Number,
    shouldCopySpiral: Boolean,
  },
  data() {
    return {
      spiral: {
        name: null,
        color: null,
        nodeLength: null,
        gramPerNode: null,
        nodesPerRoll: null,
        pricePerMeter: null,
        description: null,
      },
    };
  },
  methods: {
    getSpiral() {
      if (this.id === 0) return;
      api
        .get(services.itemCount.getSpiral, {
          getSpiral: true,
          id: this.id,
        })
        .then((data) => {
          this.spiral = data;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    saveSpiral() {
      const spiral = this.spiral;
      if (this.shouldCopySpiral) delete spiral.id;
      api
        .post(services.itemCount.setSpiral, {
          setSpiral: true,
          spiral: JSON.stringify(spiral),
        })
        .then((data) => {
          if (data.id) {
            this.$parent.spiralId = data.id;
            this.$parent.shouldCopySpiral = false;
          }

          this.$emit('saved');
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    closeSpiral() {
      this.$emit('close');
    },
  },
  mounted() {
    this.getSpiral();
  },
  watch: {
    id(to) {
      if (to) {
        this.getSpiral();
      }
    },
  },
};
</script>
